import React from "react";

export default function DataSyncHistory() {
  const headers = [
    "Index",
    "ID",
    "Timestamp",
    "Level",
    "Message",
    "Method",
    "URL",
    "Metadata ID",
    "Detail",
  ];
  return (
    <>
      <table className="table-custom w-100">
        <thead>
          <tr>
            {headers.map((header, index) => (
              <td key={index} style={{ textAlign: "center" }}>
                {header}
              </td>
            ))}
          </tr>
        </thead>
      </table>
    </>
  );
}
